/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Type with identifier status that is used for filtering.
 *
 */
export var AssetTypePropertyWithStatusForFiltering;
(function (AssetTypePropertyWithStatusForFiltering) {
    AssetTypePropertyWithStatusForFiltering["ASSET_SOURCE_TYPE"] = "assetSourceType";
    AssetTypePropertyWithStatusForFiltering["ASSET_ID"] = "assetId";
    AssetTypePropertyWithStatusForFiltering["ASSET_IDENTIFIER_STATUS"] = "assetIdentifierStatus";
})(AssetTypePropertyWithStatusForFiltering || (AssetTypePropertyWithStatusForFiltering = {}));
